export var SoundSettingsEnum;
(function (SoundSettingsEnum) {
    SoundSettingsEnum["BLOOP"] = "BLOOP";
    SoundSettingsEnum["TODO"] = "TODO";
    SoundSettingsEnum["TRUM"] = "TRUM";
    SoundSettingsEnum["UWA"] = "UWA";
    SoundSettingsEnum["VOOP"] = "VOOP";
    SoundSettingsEnum["WOOSH"] = "WOOSH";
    SoundSettingsEnum["DISABLED"] = "DISABLED";
})(SoundSettingsEnum || (SoundSettingsEnum = {}));
